import type { JSX } from 'react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthLayout } from './AuthLayout';

type State = 'loading' | 'no_access' | 'error';

export function LandingPage(): JSX.Element {
  const navigate = useNavigate();
  const [state, setState] = useState<State>('loading');

  useEffect(() => {
    let cancelled = false;

    fetch('/api/vetting/auth/me', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(async (res) => {
        if (res.status === 401) {
          if (!cancelled) setState('no_access');
          return;
        }
        if (!res.ok) {
          if (!cancelled) setState('error');
          return;
        }
        const data = (await res.json()) as {
          email: string;
          role: 'registrar' | 'approver';
          parishSlugs: string[];
        };
        if (cancelled) return;
        if (data.role === 'registrar') {
          navigate('/registrar', { replace: true });
        } else if (data.parishSlugs.length > 0) {
          navigate(`/parish/${data.parishSlugs[0]}`, { replace: true });
        } else {
          setState('no_access');
        }
      })
      .catch(() => {
        if (!cancelled) setState('error');
      });

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  if (state === 'loading') {
    return (
      <AuthLayout>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 200,
            color: 'var(--text2)',
            fontSize: 14,
          }}
        >
          Loading…
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout>
      <div style={{ maxWidth: 384, margin: '0 auto', textAlign: 'center' }}>
        <h2 style={{ fontSize: 20, fontWeight: 600, color: 'var(--text)', marginBottom: 12 }}>
          Restricted Access
        </h2>
        <p style={{ fontSize: 14, color: 'var(--text2)', marginBottom: 24, lineHeight: 1.6 }}>
          This portal is for authorised parish vetting approvers only.
        </p>
        {state === 'error' && (
          <p style={{ fontSize: 14, color: 'var(--red)', marginBottom: 24 }}>
            An error occurred. Please try again or contact us below.
          </p>
        )}
        <p style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 32, lineHeight: 1.6 }}>
          If you believe this is an error, please email{' '}
          {/* The shared .btn-link: the AA link tone AND an underline. A link in
              running text must not be told apart by colour alone (WCAG 2.2
              SC 1.4.1, axe link-in-text-block); this one was, in --brand. */}
          <a href="mailto:nzpv@confessinganglicans.nz" className="btn-link">
            nzpv@confessinganglicans.nz
          </a>
        </p>
        <a
          href="/auth/login"
          className="btn btn-primary"
          style={{ display: 'inline-flex', justifyContent: 'center', minWidth: 160 }}
        >
          Sign In
        </a>
      </div>
    </AuthLayout>
  );
}
